














// vendor
import { defineComponent, computed, ref, watch } from "@vue/composition-api";
// project
import * as AssetAPI from "@/services/api/assets";
import { Asset, AssetVersion } from "@/psychlab/types/assets";
import { PreviewAssetForm } from "@/components.assets/preview-asset-form";
import { PreviewAssetGraph } from "@/components.assets/preview-asset-graph";
import { PreviewAssetCognitiveTest } from "@/components.assets/preview-asset-cognitivetest";
import { PreviewAssetGallery } from "@/components.assets/preview-asset-gallery";
import { generateGUID } from "@/utils/guid";
import { DisplayJSON } from "@/components.generic/display-code";
import { default as FallbackPreview } from "./fallback-preview.vue";

export default defineComponent({

	emits:[
		"input"
	],
	props:{
		type:{
			type:String,
			required:true
		},
		data:{
			type:Object,
			required:true,
		},
		version:{
			type:String,
			required:true,
		}
	},
	components:{
		"display-json":DisplayJSON,
	},
	setup(props){

		const typeComponent = computed(() => {
			return ({
				"Form":PreviewAssetForm,
				"Graph":PreviewAssetGraph,
				"CognitiveTest":PreviewAssetCognitiveTest,
				"Gallery":PreviewAssetGallery,
			} as any)[props.type] || FallbackPreview;;
		});


		return {
			typeComponent,
		};
	}
});

